<template>
    <div class="animated fadeIn">
        <div>
            <b-row>
                <b-col cols="12">
                    <b-button v-on:click="goBack" variant="secondary">
                        <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <h1>Past Reports</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Downloadable Reports</strong>
                        </div>
                        <div v-if="!reportListLoaded" class="form-container">
                            <LoadingSpinner />
                        </div>
                        <div v-if="reportListLoaded" class="form-container">
                            <b-row>
                                <b-col>
                                    <p>Select a report to download in Excel format.</p>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12">
                                    <div id="user-reports-list">
                                        <b-table
                                            id="user-reports-table"
                                            class="datalist-table"
                                            selectable
                                            hover
                                            bordered
                                            select-mode="single"
                                            :items="userReportsList"
                                            :fields="tableFields"
                                            :per-page="perPage"
                                            :current-page="tableCurrentPage"
                                            @row-clicked="rowSelected"
                                            responsive="sm"
                                            >
                                        </b-table>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6" class="my-1">
                                    <b-pagination
                                    v-model="tableCurrentPage"
                                    :total-rows="tableTotalRows"
                                    :per-page="tablePerPage"
                                    class="my-0"
                                    ></b-pagination>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>

import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';
import cTable from '../../components/table/Table';

const getHTTPHeaders = () => {
    let userObj = JSON.parse(localStorage.getItem('user'));
    return {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Bearer ' + userObj.token,
      }
    };
}

const getPlateSizeList = (($http, userId) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get("reports/user/" + userId, headersObj)
            .then((response) => {
                const results = response.data.user_reports.map((item) => {
                    item.report_description = `Report (${item.title}) created on ${item.display_date}`;
                    return item;
                })
                resolve(response.data.user_reports);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});


export default {
  name: 'plateUsersReport',
  components: {
      LoadingSpinner: LoadingSpinner,
      cTable
  },
  data () {
    return {
        reportListLoaded: false,
        perPage: 20,
        tablePerPage: 20,
        tableCurrentPage: 1,
        tableTotalRows: 0,
        tableFields: [
            {key: 'report_description', label: 'Report', sortable: true}
        ],
        userReportsList: [],
        pageParam: ''
    }
  },
  created () {
    this.getReportsList();
  },
  methods : {
    goBack() {
        this.$router.push('/reports/' + this.$data.pageParam);
    },
    getCurrentUser () {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem('user'));
            if (user != null) {
                resolve(user);
            }
            else {
                reject();
            }
        });
    },
    rowSelected(item, index) {
        console.log(item);
        
        const link = document.createElement("a");
        link.setAttribute("href", item.path_to_report);
        link.setAttribute("download", "plate-report.xlsx");
        link.click();
    },
    getHTTPHeaders() {
      let userObj = JSON.parse(localStorage.getItem('user'));
      return {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + userObj.token,
          }
        };
    },
    getReportsList() {
        this.$data.pageParam = this.$route.params.reportpage;
        this.getCurrentUser()
            .then((userDetails) => {
                return getPlateSizeList(this.$http, userDetails.id)
            })
            .then((userReportsList) => {
                this.$data.userReportsList = userReportsList;
                this.$data.tableTotalRows = this.$data.userReportsList.length;
                this.$data.reportListLoaded = true;
            })
            .catch ((err) => {
                console.error(err);
            });
    },
  }
}
</script>
